<template>
    <div v-if="(!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
        <app-link v-if="onlyOneChild?.meta" :to="resolvePath(onlyOneChild?.path, onlyOneChild?.query)">
            <el-menu-item :index="resolvePath(onlyOneChild?.path)">
                <template #title>
                    <component :is="onlyOneChild?.meta.icon || (item.meta && item.meta.icon)" :size="20"></component>
                    <span class="title">{{ onlyOneChild?.meta.title }}</span>
                </template>
            </el-menu-item>
        </app-link>
    </div>
    <el-sub-menu v-else ref="subMenu" :index="resolvePath(item.path)">
        <template #title>
            <component :is="item.meta && item.meta.icon" :size="20"></component>
            <span class="title">{{ item.meta?.title }}</span>
        </template>
        <sidebar-item
            v-for="child in item.children"
            :key="child.id"
            :is-nest="true"
            :item="child"
            :base-path="resolvePath(child.path)"
            class="nest-menu"
        />
    </el-sub-menu>
</template>
<script setup>
import { defineProps, ref, watch } from 'vue'
import { isExternal } from '@/utils/validate'
import AppLink from './Link'

const path = require('path')

// 定义 props
const props = defineProps({
    item: {
        type: Object,
        required: true
    },
    isNest: {
        type: Boolean,
        default: false
    },
    basePath: {
        type: String
    }
})
const onlyOneChild = ref(null)
function resolvePath(routePath, routeQuery) {
    if (isExternal(routePath)) {
        return routePath
    }
    if (isExternal(props.basePath)) {
        return props.basePath
    }
    if (routeQuery) {
        // 格式化 query
        const query = JSON.parse(routeQuery.slice(1, -1))
        return { path: path.resolve(props.basePath, routePath), query }
    }
    return path.resolve(props.basePath, routePath)
}
function hasOneShowingChild(children = [], parent) {
    if (!children) {
        children = []
    }
    const showingChildren = children.filter((item) => {
        if (item.hidden) {
            return false
        } else {
            // Temp set(will be used if only has one showing child)
            onlyOneChild.value = item
            return true
        }
    })

    // When there is only one child router, the child router is displayed by default
    if (showingChildren.length === 1) {
        return true
    }

    // Show parent if there are no child router to display
    if (showingChildren.length === 0) {
        onlyOneChild.value = { ...parent, path: '', noShowingChildren: true }
        return true
    }

    return false
}
watch(
    () => props.item,
    (val) => {
        hasOneShowingChild(val.children, val)
    },
    {
        deep: true,
        immediate: true
    }
)
</script>
<style lang="scss" scoped>
svg {
    width: 15px;
    height: 20px;
    vertical-align: middle;
}
.title {
    margin-left: 5px;
}
:deep(.el-popper.is-dark) {
    background-color: pink;
    color: #fff;
}

.el-sub-menu:deep(.el-sub-menu__title) {
    border-radius: 8px;
}
.el-sub-menu:deep(.el-sub-menu__title:hover) {
    border-radius: 8px;
    color: #ffffff;
    background: var(--theme-color) !important;
}
.el-menu-item {
    border-radius: 8px;
}
.el-menu-item.is-active {
    color: #ffffff;
    background: var(--theme-color) !important;
}
.el-menu-item:hover {
    color: #ffffff;
    background: var(--theme-color) !important;
}
</style>
